// Global
import colors from "../../../config/colors";
import { masks } from "../../../utils";
import { api } from "../../../services";

// Componentes Gerais
import { CustomText } from "../../../components/index";
import { ContentFeedback } from "../../../components/index";
import { Table } from "../../../components/index";
import { Pagination } from "../../../components/index";
import ButtonMenu from "../../../components/buttons/ButtonMenu";
import Filter from "./Filters";
// removed unused modal imports; using local `ModalViewMeusdados`

// Componentes de Styles
import Styles from "../styles";
import { Add, Edit, ExpandMore, Launch, Visibility } from "@material-ui/icons";
import { fonts, SVG } from "../../../config";

// Hooks
import React from "react";
import { hooks } from "../../../utils";
import { StorageContext } from "../../../contexts/StorageContext";
import { customModal } from "../../../components/modals/utils";
import ModalViewMeusdados from "./ModalViewMeusdados";
import ModalRegistryMeusdados from "./ModaRegistryMeusdados";
import { Button } from "@material-ui/core";
import { getPlaceDefaults } from "../../../services/helpers/parseConfigParams";

// Constantes
const PAGE_SIZE = 8;

export const PROFILES = [
  {
    label: "Hóspede",
    value: "NORMAL",
  },
];


function MinhasReservas() {
  // Hooks de requisição
  const { loading, call } = hooks.useRequest();

  // State de dados
  const [reservation, setReservation] = React.useState<any>(null);
  const [placeList, setPlaceList] = React.useState<any>([]);
  const [page, setPage] = React.useState<number>(0);
  const [currentFilter, setFilter] = React.useState<any>({});
  const [isMounted, setMount] = React.useState<boolean>(false);

  // State de dados fixos de reservas
  const { getData } = React.useContext<any>(StorageContext);
  const condominiumId = getData("company_type");

  // Chamadas da API
  const Mount = React.useCallback(() => {
    call(
      null,
      api.getReservation({
        page: 0,
        size: PAGE_SIZE,
        condominiumId: condominiumId,
        type: "ADMIN",
      }),
      async (response) => {
        if (response.ok) {
          setReservation(response?.data);
        }
      }
    );
    call(
      null,
      api.getPlaces({
        page: 0,
        size: 999999,
        condominiumId: condominiumId,
      }),
      async (response) => {
        if (response.ok) {
          const list = [
            ...response?.data?.content?.map((item) => {
              const defaults = getPlaceDefaults(item?.configurationParameters);
              return {
                label: item.name,
                value: item.id,
                params: item.configurationParameters,
                defaults,
              };
            }),
          ];
          setPlaceList(list);
        }
      }
    );
  }, []);

  React.useEffect(() => {
    if (!isMounted) {
      Mount();
      setMount(true);
    }
  }, [Mount, isMounted]);

  const Submit = async (page?: number) => {
    let filters = {
      ...currentFilter,
      page: page ? page : 0,
      size: PAGE_SIZE,
      condominiumId: condominiumId,
      type: "ADMIN",
    };

    call(null, api.getReservation(filters), async (response) => {
      if (response.ok) {
        setReservation(response?.data);
        setPage(page ? page : 0);
      }
    });
  };

  // Tratamento de display
  const capitalizeText = (str) => {
    if (!str) {
      return str;
    }
    return str?.substring(0, 1)?.toUpperCase() + str?.substring(1);
  };

  const getStatus = (status: string) => {
    if (status === "FP") {
      return "Foto Pendente";
    } else if (status === "PA") {
      return "Aguardando Liberação";
    } else if (status === "AL") {
      return "Acesso Liberado";
    } else if (status === "AF") {
      return "Acesso Finalizado";
    } else if (status === "AR") {
      return "Acesso Recusado";
    } else if (status === "AC") {
      return "Acesso Cancelado";
    } else {
      return "-";
    }
  };

    const openEditModal = (item) => {
      customModal.setInfos(
        "Editar Reserva",
        ["Edite os dados da reserva selecionada:"],
        null,
        null,
        <ModalRegistryMeusdados
          page={page}
          placeList={placeList}
          reload={(value) => Submit(value)}
          oldData={item}
          optionsProfiles={PROFILES}
          edit
        />,
        false,
        true,
        <Edit />
      );
    };

  const openViewModal = (data) => {
    if (data) {
      customModal.setInfos(
        "Visualizar Ficha de Hóspedes",
        [],
          {
             onClick: () => {
               customModal.close();
             },
             label: "Voltar",
           },
           {
             onClick: () => openEditModal(data),
             label: "Editar Reserva",
           },
        <ModalViewMeusdados item={data} onSubmit={undefined} />,
        false,
        true,
        <Visibility />,
        null,
        "55vw"
      );
    }
  };

  const openModal = () => {
    customModal.setInfos(
      "Cadastrar Reserva",
      [],
      null,
      null,
      <ModalRegistryMeusdados
        page={page}
        placeList={placeList}
        reload={(value) => Submit(value)}
      />,
      false,
      true,
      <SVG.File />
    );
  };

  const getButtons = (item: any): any[] => {
    return [
      {
        label: "Visualizar Dados",
        icon: Visibility,
        onClick: () => openViewModal(item),
      },
    ];
  };

  // Função que adiciona 1 ao dia do filtro de data de criação da reserva
  function addOneDay(date: Date): Date {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + 1);
    return newDate;
  }


  // Formatação dos dados do Filtro
  // Para aplicar mais filtros, observar tela de Reserva em 'Reservation.tsx'
  const formatData = (filter?) => {
    console.log(filter);
    const filteredStatus = filter?.status
      ?.filter((obj) => obj.value !== "all")
      .map((obj) => obj.value);
    const filteredPlaces = filter?.placeName
      ?.filter((obj) => obj.value !== "all")
      .map((obj) => obj.label);
    let newFilter = {
      page: 0,
      size: PAGE_SIZE,
      condominiumId: condominiumId,
      type: "ADMIN",
      ...(filteredPlaces?.length && {
        [filteredPlaces.length > 2 ? "placeNames" : "placeName"]:
          filteredPlaces,
      }),
      ...(filter.name && { guestName: filter.name }),
      ...(filter.solicitationDate && {
            minCreatedAtDate: masks.dateToSubmit(filter.solicitationDate),
            maxCreatedAtDate: masks.dateToSubmit(
              addOneDay(filter.solicitationDate)
            ),
          }),
      ...(filteredStatus?.length > 0 && { status: filteredStatus }),
    }
    
     call(null, api.getReservation(newFilter), async (response) => {
      if (response.ok) {
        setReservation(response?.data);
        setPage(page ? page : 0);
      }
    });
  }

  // Display
  return (
    <>
      <Styles.ContainerSecondary>
        <Styles.RegitryContainer>
          <CustomText fontSize={2} textColor="#FFFFFF" fontFamily={fonts.bold}>
            Cadastrar Reserva
          </CustomText>
          <CustomText
            style={{ paddingRight: "8px" }}
            fontSize={1.75}
            textColor="#FFFFFF"
            fontFamily={fonts.regular}
          >
            Alguns dados básicos serão solicitados para o cadastro de uma nova
            reserva.
          </CustomText>
        </Styles.RegitryContainer>
        <Styles.RegitryButton
          startIcon={<Add />}
          fullWidth={false}
          onClick={openModal}
          disabled={loading}
          loading={loading}
        >
          Cadastrar
        </Styles.RegitryButton>
      </Styles.ContainerSecondary>
      <Styles.ContainerFilter>
        <CustomText
          style={{ paddingBottom: "15px" }}
          fontSize={1.75}
          textColor="#0C396D"
          fontFamily={fonts.bold}
        >
          Filtrar Reserva
        </CustomText>
        <Filter
          onSubmit={(data) => {
            formatData(data)
          }}
          loading={loading}
          placeList={placeList}
        />
      </Styles.ContainerFilter>
      <Styles.Container>
        <CustomText
          style={{ padding: "16px 20px" }}
          fontSize={2}
          textColor={colors.blue}
          fontFamily={fonts.bold}
        >
          Minhas Reservas
        </CustomText>
        <ContentFeedback data={reservation?.content} loading={loading}>
          <Table
            lastAlign={false}
            data={reservation?.content}
            renderItemColumns={(item) => [
              item?.place?.name,
              capitalizeText(item?.primaryGuest?.name),
              item?.primaryGuest?.document
                ? masks.CPF(item?.primaryGuest?.document)
                : item?.primaryGuest?.passport,
              item?.primaryGuest?.email,
              masks.formatDate(item?.startDate) +
                " " +
                masks.extractHour(item?.startDate),
              masks.formatDate(item?.endDate) +
                " " +
                masks.extractHour(item?.endDate),
              masks?.formatDate(item?.createdAt),
              <b>{getStatus(item?.status)}</b>,
              <Button
                variant="outlined"
                href={item?.primaryGuest.facialUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  backgroundColor: "#fff",
                  color: "#272727",
                  borderRadius: 10,
                  border: "solid 2px #272727",
                  fontSize: 13,
                }}
                endIcon={<Launch />}
              >
                Abrir
              </Button>,
              <ButtonMenu endIcon={<ExpandMore />} buttons={getButtons(item)}>
                Opções
              </ButtonMenu>,
            ]}
            headers={{
              table: [
                "IMOVEL",
                "NOME USUÁRIO",
                "DOCUMENTO",
                "E-MAIL",
                "CHECK-IN",
                "CHECK-OUT",
                "DATA DO CADASTRO",
                "STATUS",
                "link Reserva",
                "Ficha de Hóspedes",
              ],
              keys: [],
            }}
          />
          <Pagination
            style={{ padding: "16px 20px", paddingTop: 0 }}
            page={page + 1}
            totalPages={reservation?.totalPages}
            setPage={(number) => {
              Submit(number - 1);
            }}
          />
        </ContentFeedback>
      </Styles.Container>
    </>
  );
}

export default MinhasReservas;
